import { Phone, MessageCircle, Mail } from "lucide-react";
import { BRAND } from "@/lib/content";

// WhatsApp number = phoneHref minus "tel:" and any spaces/+
const waNumber = BRAND.phoneHref.replace(/\D/g, "");
const waUrl = `https://wa.me/${waNumber}?text=${encodeURIComponent("Bonjour FBSERVICES, je souhaite un devis.")}`;

export default function FloatingActions() {
  return (
    <>
      {/* Desktop & tablet: floating WhatsApp button bottom-left */}
      <a
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float-btn"
        aria-label="Contacter FBSERVICES par WhatsApp"
        className="hidden md:flex fixed bottom-6 left-6 z-40 items-center gap-2 rounded-full pl-3 pr-5 py-3 bg-[#25D366] text-white shadow-lg shadow-black/20 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 group"
      >
        <span className="grid place-items-center h-9 w-9 rounded-full bg-white/15">
          <MessageCircle className="h-5 w-5" />
        </span>
        <span className="text-sm font-medium">WhatsApp</span>
      </a>

      {/* Mobile: sticky bottom bar with Call + Mail */}
      <div
        data-testid="mobile-action-bar"
        className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-md border-t border-black/10 px-3 py-2.5 flex gap-2 shadow-[0_-4px_16px_rgba(0,0,0,0.06)]"
      >
        <a
          href={BRAND.phoneHref}
          data-testid="mobile-action-call"
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-full py-3 bg-[#1A4331] text-white text-sm font-medium"
        >
          <Phone className="h-4 w-4" />
          Appeler
        </a>
        <a
          href={BRAND.emailHref}
          data-testid="mobile-action-email"
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-full py-3 bg-[#D4A373] text-white text-sm font-medium"
        >
          <Mail className="h-4 w-4" />
          Mail
        </a>
      </div>
    </>
  );
}
